<template>
  <div class="search-wrapper">
    <search-comp
      @onSearch="$emit('search', searchParams)"
      @onReset="
        searchParams = { ...defaultSearchParams }
        $emit('search', searchParams)
      "
    >
      <div class="das-form-container">
        <div class="das-form-group">
          <div class="das-form-row">
            <div class="das-form-col col-4">
              <div class="das-form-input">
                <div class="label">
                  {{ 'Họ/Tên khách' }}
                </div>
                <div class="child-w-80 flex space-between gap-2">
                  <input
                    v-model="searchParams.firstName"
                    type="text"
                    placeholder="Tên"
                  />
                  <input
                    v-model="searchParams.lastName"
                    type="text"
                    placeholder="Họ"
                  />
                </div>
              </div>
            </div>
            <div class="das-form-col col-4">
              <div class="das-form-input">
                <div class="label">
                  {{ 'Nguồn' }}
                </div>
                <div class="child-w-80">
                  <select-with-search-table
                    style="width: 100%"
                    :search-fields="['desc', 'code']"
                    index-field="id"
                    :selected-index-field-value="searchParams.sourceId"
                    :value="searchParams.sourceId"
                    :rows="sourceRows"
                    :columns="sourceCols"
                    :dropdown-width="600"
                    :is-remove-btn="true"
                    @selectionChanged="onSelectSource"
                  >
                    <template v-slot:value="{ selectedValue: selectedData }">
                      <div>
                        <span>
                          {{
                            `${selectedData?.id || ''} - ${
                              selectedData?.code || ''
                            } - ${selectedData?.desc || ''}`
                          }}
                        </span>
                      </div>
                    </template>
                  </select-with-search-table>
                </div>
              </div>
            </div>
            <div class="das-form-col col-4">
              <div class="das-form-input">
                <div class="label">
                  {{ 'Mã đặt phòng' }}
                </div>
                <div class="child-w-80">
                  <input v-model="searchParams.bookingId" type="text" />
                </div>
              </div>
            </div>
          </div>
          <div class="das-form-row">
            <div class="das-form-col col-4">
              <div class="das-form-input">
                <div class="label">
                  {{ 'Ngày đến' }}
                </div>
                <div class="child-w-80">
                  <CalendarRange
                    v-model="searchParams.arriveDate"
                    style="display: block; width: 100%"
                    mode="date"
                  />
                </div>
              </div>
            </div>

            <div class="das-form-col col-4">
              <div class="das-form-input">
                <div class="label">
                  {{ 'Ngày đi' }}
                </div>
                <div class="child-w-80">
                  <CalendarRange
                    v-model="searchParams.departDate"
                    style="display: block; width: 100%"
                    mode="date"
                  />
                </div>
              </div>
            </div>

            <div v-if="!isInHouse" class="das-form-col col-4">
              <div class="das-form-input">
                <div class="label">
                  {{ 'Trạng thái đặt phòng' }}
                </div>
                <div
                  style="
                    background: #f0f0f5;
                    padding: 0 8px;
                    margin: 0;
                    height: 32px;
                    display: flex;
                    align-items: center;
                    border-radius: 5px;
                  "
                >
                  <div class="checkbox-wrap">
                    <input
                      id="isArriveToDay"
                      v-model="searchParams.isArriveToDay"
                      type="checkbox"
                    />
                    <label
                      for="isArriveToDay"
                      style="color: #606266; font-size: 14px"
                      >{{ 'Đến hôm nay' }}</label
                    >
                  </div>
                </div>
              </div>
            </div>

            <div v-else class="das-form-col col-4">
              <div class="das-form-input">
                <div class="label">
                  {{ 'Trạng thái đặt phòng' }}
                </div>
                <div
                  style="
                    background: #f0f0f5;
                    padding: 0 8px;
                    margin: 0;
                    height: 32px;
                    display: flex;
                    align-items: center;
                    border-radius: 5px;
                  "
                >
                  <div class="checkbox-wrap">
                    <input
                      id="isCheckedOutToday"
                      v-model="searchParams.isCheckedOutToday"
                      type="checkbox"
                    />
                    <label
                      for="isCheckedOutToday"
                      style="color: #606266; font-size: 14px"
                      >{{ 'Đến hạn trả phòng hôm nay' }}</label
                    >
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </search-comp>
  </div>
</template>

<script>
/* eslint-disable */
import CalendarRange from '@/components/CalendarSelect/CalendarRange.vue'

import {
  callGetRoomLevel,
  callGetRoom,
  callGetBookingGroup,
  callGetNation,
  callGetAgent,
  callGetAccount,
  callGetMarketSeg,
  callGetPriceCode,
  callGetDebitAccByAgent,
  getAllSource
} from '../utils/commonApiCall'

export default {
  components: { CalendarRange },
  props: {
    value: {
      type: Object,
      default: () => null
    },
    isInHouse: false
  },
  data() {
    return {
      searchShow: true,

      searchParams: {
        firstName: null,
        lastName: null,
        sourceId: null,
        bookingId: null, // ma dat phong
        arriveDate: {
          start: null,
          end: null
        },
        departDate: {
          start: null,
          end: null
        },
        isBooked: true,
        isArriveToDay: null,

        isInHouse: true,
        isCheckedOutToday: null,
        pageSize: 10,
        pageNum: 1,
        orderBy: null,
        orderTp: null

        // NOT USED
        // keyword: null,
        // roomLevelId: null, // ma hang phong
        // roomId: null, // ma phong
        // createDate: {
        //   start: null,
        //   end: null
        // },
        // dateOfStay: null, // ngay o
        // salesPersonId: null, // nv kinh doanh
        // agentId: null, // cty dai ly du lich
        // debtAccId: null, // tk cong no
        // marketSegId: null, // pktt
        // priceCodeId: null, // ma gia
        // nationalityId: null, // quoc tich
        // // trang thai dat
        // isDefinite: true,
        // isTentative: true,
        // isWaiting: true,
        // // trang thai dat phong
        // isNotCheckOut: true,
        // isCanceled: true,
        // isNotArrive: true,
        // isCheckout: true,
        // confirm: 0
      },
      defaultSearchParams: {
        firstName: null,
        lastName: null,
        sourceId: null,
        bookingId: null, // ma dat phong
        arriveDate: {
          start: null,
          end: null
        },
        departDate: {
          start: null,
          end: null
        },
        isBooked: true,
        isArriveToDay: null,

        isInHouse: true,
        isCheckedOutToday: null,
        pageSize: 10,
        pageNum: 1,
        orderBy: null,
        orderTp: null
      },

      // select with search table
      roomLevelRows: [],
      roomLevelCols: [
        { headerName: 'ID', field: 'id', tooltipField: 'id' },
        { headerName: 'Mã', field: 'code', tooltipField: 'code' },
        {
          headerName: 'Tên',
          field: 'name',
          tooltipField: 'name'
        }
      ],

      roomRows: [],
      roomCols: [
        { headerName: 'ID', field: 'id', tooltipField: 'id' },
        { headerName: 'Mã', field: 'code', tooltipField: 'code' },
        {
          headerName: 'Tên',
          field: 'name',
          tooltipField: 'name'
        }
      ],

      groupRows: [],
      groupCols: [
        { headerName: 'ID', field: 'id', tooltipField: 'id' },
        { headerName: 'Mã', field: 'code', tooltipField: 'code' },
        {
          headerName: 'Tên',
          field: 'name',
          tooltipField: 'name'
        }
      ],

      nationRows: [],
      nationCols: [
        { headerName: 'ID', field: 'id', tooltipField: 'id' },
        { headerName: 'Mã', field: 'code', tooltipField: 'code' },
        {
          headerName: 'Tên',
          field: 'name',
          tooltipField: 'name'
        }
      ],

      agentRows: [],
      agentCols: [
        { headerName: 'ID', field: 'id', tooltipField: 'id' },
        { headerName: 'Mã', field: 'code', tooltipField: 'code' },
        {
          headerName: 'Tên',
          field: 'name',
          tooltipField: 'name'
        }
      ],

      debitAccRows: [],
      debitAccCols: [
        { headerName: 'ID', field: 'id', tooltipField: 'id' },
        { headerName: 'Mã', field: 'code', tooltipField: 'code' },
        {
          headerName: 'Tên',
          field: 'name',
          tooltipField: 'name'
        }
      ],

      accRows: [],
      accCols: [
        { headerName: 'ID', field: 'id', tooltipField: 'id' },
        { headerName: 'Mã', field: 'code', tooltipField: 'code' },
        {
          headerName: 'Tên',
          field: 'name',
          tooltipField: 'name'
        }
      ],

      marketSegRows: [],
      marketSegCols: [
        { headerName: 'ID', field: 'id', tooltipField: 'id' },
        { headerName: 'Mã', field: 'code', tooltipField: 'code' },
        {
          headerName: 'Tên',
          field: 'name',
          tooltipField: 'name'
        }
      ],

      priceCodeRows: [],
      priceCodeCols: [
        { headerName: 'ID', field: 'id', tooltipField: 'id' },
        { headerName: 'Mã', field: 'code', tooltipField: 'code' },
        {
          headerName: 'Tên',
          field: 'name',
          tooltipField: 'name'
        }
      ],

      sourceRows: [],
      sourceCols: [
        {
          headerName: 'ID',
          field: 'id',
          tooltipField: 'id'
        },
        {
          headerName: 'Mã',
          field: 'code',
          tooltipField: 'code'
        },
        {
          headerName: 'Mô tả',
          field: 'desc',
          tooltipField: 'desc'
        }
      ],

      // select
      confirm: JSON.stringify({ label: 'Tất cả', id: null }),
      confirmOptions: [
        { label: 'Tất cả', id: null },
        { label: 'Chưa xác nhận', id: false },
        { label: 'Đã xác nhận', id: true }
      ],

      // dialog
      dialogGroupVisible: false,
      groupSearchParams: {
        pageSize: null,
        pageNum: null,
        orderBy: null,
        orderTp: null,
        info: null,
        agent: null,
        firstArrival: {
          start: null,
          end: null
        },
        lastDepDate: {
          start: null,
          end: null
        },
        roomDate: {
          start: null,
          end: null
        },
        releaseDate: null,
        bookStayOverDate: null,
        status: null
      },
      defaultGroupSearchParams: {
        pageSize: null,
        pageNum: null,
        orderBy: null,
        orderTp: null,
        info: null,
        agent: null,
        firstArrival: {
          start: null,
          end: null
        },
        lastDepDate: {
          start: null,
          end: null
        },
        roomDate: {
          start: null,
          end: null
        },
        releaseDate: null,
        bookStayOverDate: null,
        status: null
      },
      groupSearchShow: true,
      groupLoading: false,
      groupColumns: [
        {
          headerName: 'Trạng thái',
          field: ''
        },
        {
          headerName: 'Xác nhận',
          field: ''
        },
        {
          headerName: 'Mã đoàn',
          field: ''
        },
        {
          headerName: 'Mã định danh ngoài',
          field: ''
        },
        {
          headerName: 'Tên đoàn',
          field: ''
        },
        {
          headerName: 'Đại lý du lịch',
          field: ''
        },
        {
          headerName: 'Ngày đến đầu',
          field: ''
        },
        {
          headerName: 'Ngày đi cuối',
          field: ''
        },
        {
          headerName: 'Người tạo',
          field: ''
        },
        {
          headerName: 'Thời gian tạo',
          field: ''
        },
        {
          headerName: 'Ghi chú',
          field: ''
        }
      ],
      groupRowss: [],
      selectedRow: []
    }
  },

  watch: {
    value(nv, ov) {
      if (nv) {
        this.searchParams = nv
      } else {
        this.searchParams = { ...this.defaultSearchParams }
      }
    }
  },

  async mounted() {
    // this.roomLevelRows = await callGetRoomLevel()
    // this.roomRows = await callGetRoom()
    // this.groupRows = await callGetBookingGroup()
    // this.nationRows = await callGetNation()
    // this.agentRows = await callGetAgent()
    // this.accRows = await callGetAccount()
    // this.marketSegRows = await callGetMarketSeg()
    // this.priceCodeRows = await callGetPriceCode()
    // this.onSelectStatusChanged()
    this.sourceRows = await getAllSource()

    // auto select for multi select
  },

  methods: {
    // handle event
    onSelectRoomLevel(data) {
      this.searchParams.roomLevelId = data?.id || null
    },
    onSelectRoom(data) {
      this.searchParams.roomId = data?.id || null
    },
    onSelectGroup(data) {
      this.searchParams.bookingId = data?.id || null
    },
    onSelectNation(data) {
      this.searchParams.nationalityId = data?.id || null
    },
    async onSelectAgent(data) {
      this.searchParams.agentId = data?.id || null
      if (this.searchParams.agentId) {
        this.debitAccRows = await callGetDebitAccByAgent({
          agentId: this.searchParams.agentId
        })
      } else {
        this.searchParams.debtAccId = null
      }
    },
    onSelectDebitAcc(data) {
      this.searchParams.debtAccId = data?.id || null
    },
    onSelectAcc(data) {
      this.searchParams.salesPersonId = data?.id || null
    },
    onSelectMarketSeg(data) {
      this.searchParams.marketSegId = data?.id || null
    },
    onSelectPriceCode(data) {
      this.searchParams.priceCodeId = data?.id || null
    },
    onSelectSource(data) {
      this.searchParams.sourceId = data?.id || null
    },
    onSelectStatusChanged() {
      this.searchParams.isArriveToDay = false
      this.searchParams.isNotCheckOut = false
      this.searchParams.isCanceled = false
      this.searchParams.isNotArrive = false

      this.bookingState.forEach(item => {
        switch (item) {
          case 1:
            this.searchParams.isArriveToDay = true
            break
          case 2:
            this.searchParams.isNotCheckOut = true
            break
          case 3:
            this.searchParams.isCanceled = true
            break
          case 4:
            this.searchParams.isNotArrive = true
            break
          default:
            break
        }
      })
    }
  }
}
</script>
